module.exports = __webpack_public_path__ + "static/media/CHAP02-TITRE-VIDEO.1a5c2fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CHAP02-TITRE-VIDEO.png
// module id = 260
// module chunks = 0